import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Container, Col, Row, Button } from "react-bootstrap";

import NavbarComponent from '../components/NavbarComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import AlertSuccessComponent from '../components/AlertSuccessComponent';
import LoadingComponent from '../components/LoadingComponent';

import { SUCCESS }  from "../constants/ApiResult";

const axios = require('axios').default;
//var FormData = require('form-data');

/*
let account = AccountITest.filter( (obj) => {
    if(AccountProd.findIndex( (foo) => foo.GoodsCode === obj.GoodsCode ) === -1) {
        return true;
    }
});

console.log(account);
*/

class SupplierDataOperations extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            apiErrorMessage:'',
            syncSuccessful:false,
            syncDataSuccessful:false,
            syncDataProductsSuccessful:false,
            syncDataInventoryBranchMappingSuccessful:false,
            syncDataBranchesSuccessful:false,
            isLoading:false,
            getDataAPI:false,
            data:[],
            getITestDataAPI:false,
            itestData:[],
            getDataProductsAPI:false,
            dataProducts:[],
            getITestDataProductsAPI:false,
            dataITestProducts:[],
            getITestDataUnitsInfoAPI:false,
            iTestDataUnitsInfo:[],
            getInventoryBranchMappingAPI:false,
            dataInventoryBranchMapping:[],
            getITestDepartmentsAPI:false,
            dataDepartments:[]
        }
    }

    componentDidMount() {
        this.getDataAPI();
        this.getITestDataAPI();
        this.getDataProductsAPI();
        this.getITestDataProductsAPI();
        this.getITestDataUnitsInfoAPI();

        /*
        var text;
        for (let i = 130; i <= 229; i++) {
          if(i === 130){
            text = JSON.stringify({"businessId":i});
          } else {
            text += JSON.stringify(`,{"businessId":${i}}`);
          }
        }
        console.log(text);
       */

    }

/*
Config
*/

    getConfigProperty = (property) => {
        if(process.env.REACT_APP_ENV === "dev") {
            return this.props.auth["suppliersItestConfig"][property];
        } else if(process.env.REACT_APP_ENV === "itest") {
            return this.props.auth["suppliersUATConfig"][property];
        }
    }

/*
API
*/

/* (Get) Data */

    getDataAPI = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/data`, 
        {
            params:{ 
                supplierId:this.props.auth.supplierId,
                deliveryLine:[1, 20]
            },
            headers: {
            'Authorization': `Basic ${this.props.auth.token}`,
            }
        })
        .then( (res) => {
            this.setState({
                data:res.data.data,
                getDataAPI:true
            })
        })
        .catch( (err) => {
            console.error(err);
            this.setState({
                apiErrorMessage: 'Bad Request (500)',
                getDataAPI:true
            });
        });
    }

/* (Get) iTest Data */

    getITestDataAPI  = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data`, 
        {
            params:{ 
                supplierId:this.getConfigProperty("supplierId"),
                env:process.env.REACT_APP_ENV
            },
            headers: {
            'Authorization': `Basic ${this.props.auth.token}`,
            }
        })
        .then( (res) => {
            this.setState({
                itestData:res.data.data,
                getITestDataAPI:true
            })
        })
        .catch( (err) => {
            console.error(err);
            this.setState({
                apiErrorMessage: 'Bad Request (500)',
                getITestDataAPI:true
            });
        });
    }

/* (Get) iTest Data Products */

getITestDataProductsAPI  = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data/products`, 
    {
        params:{ 
            supplierId:this.getConfigProperty("supplierId")
        },
        headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
        }
    })
    .then( (res) => {

        this.setState({
            dataITestProducts:res.data.data,
            getITestDataProductsAPI:true
        })
    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            apiErrorMessage: 'Bad Request (500)',
            getDataProductsAPI:true
        });
    });
}

/* (Get) Data Products */

getDataProductsAPI  = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/data/products`, 
    {
        params:{ 
            supplierId:this.props.auth.supplierId
        },
        headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
        }
    })
    .then( (res) => {

        this.setState({
            dataProducts:res.data.data,
            getDataProductsAPI:true
        })
    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            apiErrorMessage: 'Bad Request (500)',
            getDataProductsAPI:true
        });
    });
}

/* (Get) iTest Data Units Info */

getITestDataUnitsInfoAPI  = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data/unitsinfo`, 
    {
        params:{ 
            
        },
        headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
        }
    })
    .then( (res) => {
        this.setState({
            iTestDataUnitsInfo:res.data.data,
            getITestDataUnitsInfoAPI:true
        })
    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            apiErrorMessage: 'Bad Request (500)',
            getITestDataUnitsInfoAPI:true
        });
    });
}

/* (GET) iTest Departments */

getITestDepartmentsAPI = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data/departments`,{
        headers: {
          Authorization: 'Basic ' + this.props.auth.token
        }
    })
    .then( (res) => {
        if(res.data.data.length === 0) {
            this.setState({
                isLoading:false,
                apiErrorMessage: 'Bad Request (400)'
            }); 
        } else {
         
            this.setState({
                getITestDepartmentsAPI:true,
                dataDepartments:res.data.data
            }, () => {
                this.getDataInventoryBranchMappingAPI();
            });
        }
    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            apiErrorMessage: 'Bad Request (500)',
            getITestDataDepartmentsAPI:true
        });
    });
}

/* (GET) Inventory Branch Mapping */

getDataInventoryBranchMappingAPI = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/data/inventoryBranchMapping`, {
        headers: {
            "Authorization": 'Basic ' + this.props.auth.token     
        }
    })   
    .then( (res) => {
        if(res.data.data.length) {
            res.data.data.forEach( (row, index) => {
                if(row.DepId > 0) {
                    let dep = this.state.dataDepartments.filter( (obj) => obj.BranchCode === row.BranchCode && obj.DepName === row.DepName )[0];
                    
                    if(dep) {
                        res.data.data[index].DepId = dep.DepId;
                    }
                }
            });
            this.setState({
                getInventoryBranchMappingAPI:true,
                dataInventoryBranchMapping:res.data.data.slice(0,1)
            }, () => {
                this.postITestInventoryBranchMappingAPI(res.data.data.slice(0,1))
            });
        } else {
            this.setState({
                isLoading:false,
                apiErrorMessage: 'Bad Request (400)'
            }); 
        }

    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            apiErrorMessage: 'Bad Request (500)',
            getITestDataDepartmentsAPI:true
        });
    });
}


/* (GET) Inventory Branch Mapping */
/*
getDataInventoryBranchMappingAPI = () => {
    
    axios.all([
        axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/data/inventoryBranchMapping`, {
            headers: {
                "Authorization": 'Basic ' + this.props.auth.token     
            }
        }),
        axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data/departments`,{
            headers: {
              Authorization: 'Basic ' + this.props.auth.token
            }
        })
    ])
    .then( axios.spread((res1, res2) => {

        if(res1.data.data.length && res2.data.data.length) {
            
            res1.data.data.forEach( (row, index) => {
                if(row.DepId > 0) {
                    // replace res1.data (inventoryBranchMapping depId with res2.data depId);
                    let dep = res2.data.data.filter( (obj) => obj.BranchId === row.BranchId && obj.DepName === row.depName )[0];
                    if(dep) {
                        res1.data.data[index].DepId = dep.DepId;
                    }
                }
            });

            this.setState({
                dataInventoryBranchMapping:res1.data.data,
                getInventoryBranchMappingAPI:true
            }, () => {
                this.postITestInventoryBranchMappingAPI(res1.data.data)
            });

        } else {
            this.setState({
                isLoading:false,
                apiErrorMessage: 'Bad Request (400)'
            }); 
        }

    }))
    .catch( (err) => {
        console.error(err);
        this.setState({
            apiErrorMessage: 'Bad Request (500)',
            getInventoryBranchMappingAPI:true
        });
    });
}
*/

/* (POST) iTest Data */

postITestDataAPI  = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data`,{
        supplierIdUAT:this.getConfigProperty("supplierId"),
        poIdUAT:this.getConfigProperty("poId"),
        dataInsert:this.getInsertUpdateBusinesses('insert'),
        //dataUpdate:this.getInsertUpdateBusinesses('update')
        dataUpdate:[]
    },{
    headers: {
      Authorization: 'Basic ' + this.props.auth.token
    }
   }).then( (res) => {
        if(res.data.result === SUCCESS) {
            this.setState({
                syncDataSuccessful:true,
                getITestDataDepartmentsAPI:true,
                dataDepartments:res.data.data

            }, () => {
                this.getDataInventoryBranchMappingAPI();
            });
        } else {
            this.setState({
                isLoading:false,
                apiErrorMessage: 'Bad Request (400)'
            });
        }
    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            isLoading:false,
            apiErrorMessage: 'Bad Request (500)'
        });
    });
}

/* (POST) iTest Data Branches */

postITestDataBranchesAPI  = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data/branches`,{
        supplierIdUAT:this.getConfigProperty("supplierId"),
        poIdUAT:this.getConfigProperty("poId"),
        dataInsert:this.getInsertUpdateBranches('insert'),
        dataUpdate:this.getInsertUpdateBranches('update')
    },{
    headers: {
      Authorization: 'Basic ' + this.props.auth.token
    }
   }).then( (res) => {
        if(res.data.result === SUCCESS) {
            this.setState({
                isLoading:false,
                syncSuccessful:true,
                syncDataBranchesSuccessful:true
            });
        } else {
            this.setState({
                isLoading:false,
                apiErrorMessage: 'Bad Request (400)'
            });
        }
    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            isLoading:false,
            apiErrorMessage: 'Bad Request (500)'
        });
    });
}

/* (POST) iTest Data Products */

postITestDataProductsAPI  = () => {
    console.log(this.getITestDataProducts());
    return;
    /*
    axios.post(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data/products`,{
        supplierIdUAT:this.getConfigProperty("supplierId"),
        poIdUAT:this.getConfigProperty("poId"),
        data:this.getITestDataProducts(),
        env:process.env.REACT_APP_ENV 
    },{
    headers: {
      Authorization: 'Basic ' + this.props.auth.token
    }
    }).then( (res) => {
        if(res.data.result === SUCCESS) {
            this.setState({
                syncDataProductsSuccessful:true
            }, () => {
                this.isSyncSuccessful();
            });
        } else {
            this.setState({
                isLoading:false,
                apiErrorMessage: 'Bad Request (400)'
            });
        }
    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            isLoading:false,
            apiErrorMessage: 'Bad Request (500)'
        });
    });
    */
}

/* (POST) iTest Inventory Branch Mapping */

postITestInventoryBranchMappingAPI  = (data) => {

    axios.post(`${process.env.REACT_APP_API_URL}/api/supplier/cd/itest/data/inventoryBranchMapping`,{
        supplierIdUAT:this.getConfigProperty("supplierId"),
        data:data
    },{
    headers: {
      Authorization: 'Basic ' + this.props.auth.token
    }
    }).then( (res) => {
        if(res.data.result === SUCCESS) {
            this.setState({
                syncDataInventoryBranchMappingSuccessful:true
            }, () => {
                this.isSyncSuccessful();
            });
        } else {

            this.setState({
                isLoading:false,
                apiErrorMessage: 'Bad Request (400)'
            });
        }
    })
    .catch( (err) => {
        console.error(err);
        this.setState({
            isLoading:false,
            apiErrorMessage: 'Bad Request (500)'
        });
    });
}

/*
    Get Insert / Update Businesses
*/

getInsertUpdateBusinesses = (mode) => {
    let data = [];
    if(mode === "insert") {
        data = this.state.data.filter( (a) => this.state.itestData.findIndex( (b) => b.Account === a.Account ) === -1 );
    } else if( mode === "update") {
        data = this.state.data.filter( (a) => this.state.itestData.findIndex( (b) => b.Account === a.Account ) > -1 );
    }
    let payload = [];
    data.forEach( (row) => {
        let buIndex = payload.findIndex( (obj) => obj.Account === row.Account );
        if(buIndex === -1) {
            // first occurance
            payload.push({
                "BusinessId":row.BusinessId,
                "BusinessName":row.BusinessName,
                "Account":row.Account,
                "Branches":[{
                    "BranchName":row.BranchName,
                    "Address":row.Address,
                    "PhoneNum":row.PhoneNum,
                    "ShortCall":row.ShortCall,
                    "branchCode":row.branchCode,
                    "DeliveryLine":row.DeliveryLine,
                    "Departments":[{
                        "DepName":row.DepName,
                        "DepartmentItemType":row.ItemTypeId,
                        "Operator":{
                            "OperatorName":row.OperatorName,
                            "Password":row.Password,
                            "SessionKey":row.SessionKey,
                            "FirstName":row.FirstName,
                            "LastName":row.LastName
                        }
                    }],
                    "Storage":{
                        "StorageName":row.StorageName,
                        "StorageTypeId":row.StorageTypeId
                    }
                }]
            });
        } else {
            // not first occurance
            let bIndex = payload[buIndex].Branches.findIndex( (obj) => obj.branchCode === row.branchCode );
            
            if(bIndex === -1) {
                payload[buIndex].Branches.push({
                    "BranchName":row.BranchName,
                    "Address":row.Address,
                    "PhoneNum":row.PhoneNum,
                    "ShortCall":row.ShortCall,
                    "branchCode":row.branchCode,
                    "DeliveryLine":row.DeliveryLine,
                    "Departments":[{
                        "DepName":row.DepName,
                        "DepartmentItemType":row.ItemTypeId,
                        "Operator":{
                            "OperatorName":row.OperatorName,
                            "Password":row.Password,
                            "SessionKey":row.SessionKey,
                            "FirstName":row.FirstName,
                            "LastName":row.LastName
                        }
                    }],
                    "Storage":{
                        "StorageName":row.StorageName,
                        "StorageTypeId":row.StorageTypeId
                    }
                });
            } else {
                payload[buIndex].Branches[bIndex].Departments.push({
                    "DepName":row.DepName,
                    "DepartmentItemType":row.ItemTypeId,
                    "Operator":{
                        "OperatorName":row.OperatorName,
                        "Password":row.Password,
                        "SessionKey":row.SessionKey,
                        "FirstName":row.FirstName,
                        "LastName":row.LastName
                    }
                });
            }
        }
    });

    if(mode === "insert") {
        //return payload.slice(0,100);
        return payload;
    } else {
        return payload;
    }
}

/*
    Get Insert / Update Businesses
*/

getInsertUpdateBranches = (mode) => {
    let data = [];
    if(mode === "insert") {
        // find which branchCode doesn't exist in production
        this.state.data.forEach( (obj, index) => {
            let itestDataFilter = this.state.itestData.filter( (_obj) =>  _obj.Account === obj.Account && _obj.ContactUser === 'Agora Hub' )[0];
            if(itestDataFilter) {
                if(itestDataFilter.BranchCodes.indexOf(obj.branchCode) === -1) {
                    obj.BusinessId = itestDataFilter.BusinessId;
                    data.push(obj);
                }
            }
        });

        let payload = [];
        data.forEach( (row) => {
            let index = payload.findIndex( (obj) => obj.branchCode === row.branchCode );
            if(index === -1) {
                // first occurance
                payload.push({
                    "BusinessId":row.BusinessId,
                    "BusinessName":row.BusinessName,
                    "Account":row.Account,
                    "BranchName":row.BranchName,
                    "Address":row.Address,
                    "PhoneNum":row.PhoneNum,
                    "ShortCall":row.ShortCall,
                    "branchCode":row.branchCode,
                    "DeliveryLine":row.DeliveryLine,
                    "Departments":[{
                        "DepName":row.DepName,
                        "DepartmentItemType":row.ItemTypeId,
                        "Operator":{
                            "OperatorName":row.OperatorName,
                            "Password":row.Password,
                            "SessionKey":row.SessionKey,
                            "FirstName":row.FirstName,
                            "LastName":row.LastName
                        }
                    }],
                    "Storage":{
                        "StorageName":row.StorageName,
                        "StorageTypeId":row.StorageTypeId
                    }
                });
            } else {
                payload[index].Departments.push({
                    "DepName":row.DepName,
                    "DepartmentItemType":row.ItemTypeId,
                    "Operator":{
                        "OperatorName":row.OperatorName,
                        "Password":row.Password,
                        "SessionKey":row.SessionKey,
                        "FirstName":row.FirstName,
                        "LastName":row.LastName
                    }
                });
            }
        });
    
        return payload;


    } else {
        // not needed
        return [];
    }
}

/*
Get ITest Data Products 
*/

getITestDataProducts = () => {
    let dataProducts = JSON.parse(JSON.stringify(this.state.dataProducts));
    let dataITestProducts = JSON.parse(JSON.stringify(this.state.dataITestProducts));

    let data = {
        "insert":[],
        "update":[]
    }

    // split into insert/update products
    data.insert = dataProducts.filter((product) => dataITestProducts.findIndex( (obj) => obj.GoodsCode === product.GoodsCode ) === -1 );
    data.update = dataProducts.filter((product) => dataITestProducts.findIndex( (obj) => obj.GoodsCode === product.GoodsCode ) > -1 );

    // replace all the unitId with the production ones
    for (let key in data) {
        data[key].forEach( (product, index) => {
            let unitInfo = this.state.iTestDataUnitsInfo.filter( (unit) => unit.UnitName === product.UnitName )[0];
            if(unitInfo) {
                data[key][index].UnitId = unitInfo.UnitId;
            } else {
                this.setState({
                    isLoading:false,
                    apiErrorMessage:'Unit Name production mapping error'
                });
            };
        });
    }
    return data;
}

/*
(State) Is Sync Successful
*/

    isSyncSuccessful = () => {
       if(this.state.syncDataSuccessful && this.state.syncDataProductsSuccessful && this.state.syncDataInventoryBranchMappingSuccessful) {
            this.setState({
                syncSuccessful:true,
                isLoading:false
            });
        }
    }

/*
(Boolean) Is Loading
*/

    isAPILoading = () => {
        if(
        this.state.getDataAPI && 
        this.state.getITestDataAPI && 
        this.state.getDataProductsAPI &&
        this.state.getITestDataProductsAPI && 
        this.state.getITestDataUnitsInfoAPI) {  
            return false;
        }
        return true;
    }

/*
(State)    Handle Syncronise Data
*/

    handleSyncroniseData = () => {
        this.setState({
            isLoading:true
        }, () => {
            (async () => {
                
                await this.postITestDataAPI();
                //this.postITestDataProductsAPI();

                // Run this to insert branches to existing businesses
                // this.postITestDataBranchesAPI();
            })();
        });
    }
  
    render() {
        return (
            <Container className="p-0">
                {this.props.auth.isLogin && <NavbarComponent />}
                <Container fluid>
                    <Row>
                        <Col xs={12} className="mt-4">
                            <h1>Supplier Data Operations</h1>
                        </Col>
                    </Row>
                    {this.isAPILoading() || this.state.isLoading
                    ?
                        <LoadingComponent />
                    :
                    <>
                        <Row>
                            <Col xs={12}>
                                {
                                    this.state.apiErrorMessage
                                    ?
                                    <div className="mt-4">
                                        <AlertErrorComponent label={this.state.apiErrorMessage} />
                                    </div>
                                    :
                                    <div className="mt-4">
                                        {this.state.syncSuccessful &&
                                            <AlertSuccessComponent label={`Data Operations Syncronise Successful`} />
                                        }
                                        <div className="mt-4">
                                            <Button 
                                            type="button" 
                                            variant="primary" 
                                            onClick={ () => this.handleSyncroniseData()}>
                                                Syncronise Data
                                            </Button> 
                                        </div>
                                    </div>
                                }
                            </Col>
                        </Row>
                    </>
                    }
                </Container>
            </Container>
        )
    }

}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

export default connect(mapStateToProps, null)(withRouter(SupplierDataOperations));
